export const CHECK_NEW_REQUEST_CONFIG = {
  management: {
    apiPath: "SLN/Management/CheckNewRequest",
    listPath: "/SLN/Management/CheckNewRequest",
    assignmentSource: "Management",
  },
  solarentOperator: {
    apiPath: "SLN/SolarentOperator/CheckNewRequest",
    listPath: "/SLN/SolarentOperator/CheckNewRequest",
    assignmentSource: "SolarentOperator",
  },
};
